"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CONSTANTS = require("../lib/CONSTANTS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var D3_CDN_URL = 'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.16/d3.min.js'; // only load d3 once, even though we might have multiple ActionTree components on the page.

var d3Loaded = false;

var ActionTree = /*#__PURE__*/function (_React$Component) {
  _inherits(ActionTree, _React$Component);

  var _super = _createSuper(ActionTree);

  function ActionTree(props) {
    _classCallCheck(this, ActionTree);

    return _super.call(this, props);
  }

  _createClass(ActionTree, [{
    key: "injectStyle",
    value: function injectStyle() {
      var css = "\n            rect.bar {\n                cursor: pointer;\n                fill: #fff;\n                fill-opacity: .5;\n                stroke: #3182bd;\n                stroke-width: 1.5px;\n            }\n            rect.log {\n                cursor: pointer;\n                fill: #E6E6E6;\n                fill-opacity: .5;\n                stroke: #3182bd;\n                stroke-width: 1px;\n            }\n            .node>text {\n                cursor: pointer;\n                font: 10px sans-serif;\n            }\n            path.link {\n                fill: none;\n                stroke: #9ecae1;\n                stroke-width: 1.5px;\n            }\n        ";
      var head = document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);
    }
  }, {
    key: "loadScript",
    value: function loadScript(url, callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      document.getElementsByTagName('body')[0].appendChild(script);

      if (callback) {
        if (script.readyState) {
          // IE
          script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              callback();
            }
          };
        } else {
          // Others
          script.onload = callback;
        }
      }

      script.src = url;
    }
  }, {
    key: "graph",
    value: function graph() {
      if (!this.props.action) {
        return;
      }

      var relativeWidth = this.props.relativeWidth;
      var showDispatchCalls = this.props.showDispatchCalls;
      var showStartTime = this.props.showStartTime;
      var filters = ['actionCalls'];

      if (showDispatchCalls) {
        filters.push('dispatchCalls');
      }

      var root = this.props.action;
      var margin = {
        top: 30,
        right: 20,
        bottom: 30,
        left: 20
      };
      var width = 960 - margin.left - margin.right;
      var barHeight = 20;
      var barWidth = width * .8;
      var i = 0;
      var duration = 300;
      var tree = d3.layout.tree().nodeSize([0, 20]).children(function (node) {
        if (node.collapsed) {
          return null;
        }

        return filters.reduce(function (children, filter) {
          return node[filter] ? children.concat(node[filter]) : children;
        }, []).sort(function (a, b) {
          return a.startTime - b.startTime;
        });
      });
      var diagonal = d3.svg.diagonal().projection(function (d) {
        return [d.x, d.y];
      });
      var wrapper = this.refs.svgWrapper;
      var svg = d3.select(wrapper).append('svg').attr('width', width + margin.left + margin.right).append('g').attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")"));

      function update(source) {
        // Compute the flattened node list.
        var nodes = tree.nodes(source);
        var height = nodes.length * barHeight + margin.top + margin.bottom;
        d3.select(wrapper).select('svg').attr('height', height); // Compute the 'layout'.

        nodes.forEach(function (n, i) {
          var startPercent = n.parent ? (n.startTime - source.startTime) / source.duration : 0;
          var x = startPercent * barWidth;
          n.x = relativeWidth ? Math.round(x) : n.depth * barHeight;
          var durPercent = n.parent ? n.duration / source.duration : 1;
          var width = Math.round(durPercent * barWidth) || 1; // minimum 1 pixel width

          n.width = relativeWidth ? width : barWidth;
          n.y = i * barHeight;
        }); // Update the nodes…

        var node = svg.selectAll('g.node').data(nodes, function (d) {
          var id = ++i;
          d.id = d.id || id;
          return d.id;
        });
        var nodeEnter = node.enter().append('g').attr('class', 'node').attr('transform', function (d) {
          var y = d.parent ? d.parent.y : source.y;
          var x = d.parent ? d.parent.x : source.x;
          return "translate(".concat(x, ",").concat(y, ")");
        }).style('opacity', 1e-6); // Enter any new nodes at the parent's previous position.

        nodeEnter.append('rect').attr('class', 'bar').attr('y', -barHeight / 2).attr('height', barHeight).attr('width', function (d) {
          return d.width;
        }).attr('x', function (d) {
          return d.x;
        }).style('fill', color).on('click', toggleCollapse).on('mouseover', showCurrentPath).on('mouseout', showAllPaths).append('title').text(function (d) {
          return 'Click to collapse ' + d.name + '. Hover to see path to parent.';
        });
        nodeEnter.append('text').attr('class', 'displayLabel').attr('dy', 3.5).attr('dx', 5.5).attr('x', function (d) {
          return d.x + barHeight;
        }).text(createDisplayName).on('click', toggleCollapse).on('mouseover', showCurrentPath).on('mouseout', showAllPaths);
        nodeEnter.append('text').attr('class', 'payload-label').attr('height', barHeight).attr('width', barHeight).attr('dy', '3.5').attr('dx', '2').attr('x', function (d) {
          return d.x;
        }).text('{...}');
        nodeEnter.append('rect').attr('class', 'log').attr('height', barHeight).attr('width', barHeight).attr('y', -barHeight / 2).attr('x', function (d) {
          return d.x;
        }).on('click', log).append('title').text(function (d) {
          return 'Open your javascript console and click here to inspect the payload of ' + d.name;
        }); // Transition nodes to their new position.

        nodeEnter.transition().duration(duration).attr('transform', function (d) {
          return "translate(0,".concat(d.y, ")");
        }).style('opacity', 1);
        node.transition().duration(duration).attr('transform', function (d) {
          return "translate(0,".concat(d.y, ")");
        }).style('opacity', 1).select('rect').style('fill', color); // Transition exiting nodes to the parent's new position.

        node.exit().transition().duration(duration).attr('transform', function (d) {
          return "translate(0,".concat(d.parent.y, ")");
        }).style('opacity', 1e-6).remove(); // Update the links…

        var link = svg.selectAll('path.link').data(tree.links(nodes)); // Enter any new links at the parent's previous position.

        link.enter().insert('path', 'g').attr('class', 'link').attr('d', function (d) {
          return diagonal({
            source: d.source,
            target: d.source
          });
        }).transition().duration(duration).attr('d', function (d) {
          return diagonal({
            source: d.source,
            target: d.target
          });
        }); // Transition links to their new position.

        link.transition().duration(duration).attr('d', diagonal); // Transition exiting nodes to the parent's new position.

        link.exit().transition().duration(duration).attr('d', function (d) {
          return diagonal({
            source: d.source,
            target: d.source
          });
        }).remove();
      }
      /*
       * Adds `display: none` style to all links which are not
       * pointing to the current node.
       * @method showCurrentPath
       */


      function showCurrentPath(node) {
        svg.selectAll('path.link').filter(function (path) {
          if (path.target !== node) {
            return true;
          }

          return false;
        }).style('display', 'none');
      }

      function showAllPaths() {
        svg.selectAll('path.link').style('display', 'block');
      }

      function toggleCollapse(d) {
        if (d.collapsed) {
          d.collapsed = false;
        } else {
          d.collapsed = true;
        }

        update(root);
      }

      function createDisplayName(d) {
        var name = d.name;

        if (d.type && d.type !== _CONSTANTS.ACTION) {
          name = d.type + ':' + name;
        }

        if (d.context) {
          name = d.context + ':' + name;
        }

        if (typeof d.duration !== 'undefined') {
          name += " (".concat(d.duration.toFixed(2), " ms)");
        }

        if (showStartTime && typeof d.startTime !== 'undefined') {
          name += " @".concat(d.startTime);
        }

        return name;
      }

      function log(d) {
        console.log('===');
        var prefix = '';

        if (d.type === _CONSTANTS.ACTION) {
          prefix = 'Action';
        } else if (d.type === _CONSTANTS.DISPATCH) {
          prefix = 'Dispatch';
        }

        console.log(prefix + ' : ' + createDisplayName(d));
        console.log('-> Payload: %o', JSON.parse(d.payload));

        if (d.dispatchCalls) {
          console.log('-> Dispatch Calls: %o', d.dispatchCalls.map(function (c) {
            return c.name;
          }));
        }

        if (d.actionCalls) {
          console.log('-> Action Calls: %o', d.actionCalls.map(function (c) {
            return c.name;
          }));
        }

        console.log('===');
      }

      function color(d) {
        if (d.type === _CONSTANTS.DISPATCH) {
          return '#c299ff'; // dispatch node -> purple
        } else if (d.type === _CONSTANTS.ACTION) {
          if (!d.actionCalls) {
            return '#fd8d3c'; // leaf action node -> salmon
          }

          if (d.collapsed) {
            return '#3182bd'; // collapsed action node -> darker blue
          }

          return '#83b4d7'; // action node -> blue
        }

        return '#dedede'; // default -> gray
      }

      update(root);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.injectStyle();

      if (!d3Loaded) {
        this.loadScript(D3_CDN_URL, function () {
          d3Loaded = true;

          _this.graph();
        });
      } else {
        this.graph();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // wipe away old svg
      this.refs.svgWrapper.innerHTML = '';
      this.graph();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: "svgWrapper"
      });
    }
  }]);

  return ActionTree;
}(_react["default"].Component);

var _default = ActionTree;
exports["default"] = _default;